import { Play, Square } from "lucide-react";
import { cn } from "../../lib/utils";

interface FluidBlobAvatarProps {
  hue: number;
  playing: boolean;
  onToggle: (e: React.MouseEvent) => void;
  className?: string;
}

export function FluidBlobAvatar({ hue, playing, onToggle, className }: FluidBlobAvatarProps) {
  // Generate a multi-color gradient based on the voice's hue
  const color1 = `hsl(${hue}, 85%, 60%)`;
  const color2 = `hsl(${(hue + 45) % 360}, 85%, 55%)`;
  const color3 = `hsl(${(hue + 90) % 360}, 80%, 55%)`;

  return (
    <button 
      onClick={onToggle}
      className={cn(
        "relative flex items-center justify-center transition-transform outline-none w-14 h-14",
        playing ? "scale-105" : "hover:scale-105",
        className
      )}
    >
      {/* The organic morphing blob */}
      <div 
         className={cn(
           "absolute inset-0 fluid-blob transition-all duration-300 shadow-sm", 
           playing && "animate-pulse"
         )}
         style={{ 
           background: `linear-gradient(135deg, ${color1}, ${color2}, ${color3})` 
         }}
      />
      
      {/* Center play/stop button ring */}
      <div className="relative z-10 flex items-center justify-center w-[26px] h-[26px] rounded-full border border-white/60 bg-white/20 backdrop-blur-md shadow-sm transition-colors hover:bg-white/30">
         {playing ? (
           <Square className="w-2.5 h-2.5 text-white fill-current" />
         ) : (
           <Play className="w-3 h-3 text-white ml-0.5 fill-current" />
         )}
      </div>
    </button>
  );
}
